import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { CardContainer, CardWithModal, TitleAndEditButton } from 'shared-components';

import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import TripsToUk from './tripsToUk';
import { ITripToUk } from '../../../../../types';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { useNavigate } from 'react-router-dom';
import { useCustomNavigate } from '../../../../../hooks/useCustomNavigate';

const VisaPrepFormAddHistoryPage3 = (props: any) => {
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE2_3));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));

  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);

  const { navigateTo } = useCustomNavigate();
  const onEdit = () => navigateTo(`${props.params.offerId}/history/step-1`);

  // state props from store
  const defaultArr = useMemo(() => {
    return [];
  }, []);
  const tripsToUk = useSelector(({ student }: ApplicationState) => student.visa.tripsToUk, shallowEqual) || defaultArr;

  // constants
  const currentStep = 3;
  const steps = 8;

  // component state
  const [complete, setComplete] = useState(false);
  const [tripsToUkState, setTripsToUkState] = useState<ITripToUk[]>([]);
  const [showModal, setShowModal] = useState<boolean[]>([]);

  useEffect(() => {
    setTripsToUkState([
      ...tripsToUk,
      {
        arrivalDate: '',
        departureDate: '',
        purpose: '',
      },
    ]);
    setShowModal([...tripsToUk.map(_ => false), false]);
  }, [tripsToUk]);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      tripsToUk,
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, tripsToUk]);

  const toggleModal = (index: number) => {
    setShowModal(showModal.map((value, i) => (i === index ? !value : value)));
  };

  const deleteTrip = (index: number): void => {
    onChange(VQ.TRIPS_TO_UK, [...tripsToUk.slice(0, index), ...tripsToUk.slice(index + 1)]);
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'Additional History'}
    >
      <TitleAndEditButton
        title="You indicated that you have travelled to the UK in the last 10 years"
        onClick={onEdit}
      />

      <CardContainer title={`How many trips have you taken?`}>
        {tripsToUkState.map((trip: ITripToUk, index: number) => (
          <CardWithModal
            key={index}
            id={`trips-to-uk-${index}`}
            index={index}
            modalTitle={'Add Trip'}
            cardItems={[
              {
                label: 'Date of arrival',
                value: trip.arrivalDate,
              },
              {
                label: 'Date of departure',
                value: trip.departureDate,
              },
              {
                label: 'Purpose',
                value: trip.purpose,
              },
            ]}
            onRemove={deleteTrip}
            addButtonLabel={`Add Trip`}
            addAnotherButtonLabel={`I have another Trip to add`}
            hasAddMoreButton={trip.arrivalDate === '' && trip.departureDate === '' && trip.purpose === ''}
            showModal={showModal[index]}
            toggleModal={toggleModal}
          >
            <TripsToUk
              index={index}
              arrivalDate={trip.arrivalDate}
              departureDate={trip.departureDate}
              purpose={trip.purpose}
              onSaveAndClose={(trip: ITripToUk) => {
                const trips = [...tripsToUk];
                trips[index] = {
                  ...trip,
                };
                onChange(VQ.TRIPS_TO_UK, trips);
                toggleModal(index);
              }}
            />
          </CardWithModal>
        ))}
      </CardContainer>
    </QuestionPage>
  );
};
export default VisaPrepFormAddHistoryPage3;
